<template>
  <Loading :loading="loading" :loading-text="''">
    <div class="workflow-card" :class="{ 'is-library': isLibrary, 'is-archive': isArchive }">
    <!-- Card Content -->
    <div class="card-content">
      <!-- Workflow/Program Icon -->
      <div class="workflow-icon" :class="`automation-type-${automationType}`">
        <!-- Program Icon (Purple) -->
        <svg v-if="automationType === 'program'" xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
          <rect class="icon-bg" width="56" height="56" rx="8" fill="#E5F9EF"/>
          <g transform="translate(17, 18)">
            <path class="icon-fill" d="M2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V4C0 3.45 0.195833 2.97917 0.5875 2.5875C0.979167 2.19583 1.45 2 2 2H10V4H2V18H16V12H18V18C18 18.55 17.8042 19.0208 17.4125 19.4125C17.0208 19.8042 16.55 20 16 20H2ZM4 16H6V9H4V16ZM8 16H10V6H8V16ZM12 16H14V12H12V16ZM17 10C16.5 10 16.0083 9.925 15.525 9.775C15.0417 9.625 14.5917 9.40833 14.175 9.125L13.8 9.475C13.6 9.65833 13.3625 9.75 13.0875 9.75C12.8125 9.75 12.5833 9.65833 12.4 9.475C12.2167 9.29167 12.125 9.05833 12.125 8.775C12.125 8.49167 12.2167 8.25833 12.4 8.075L12.8 7.675C12.5333 7.275 12.3333 6.85 12.2 6.4C12.0667 5.95 12 5.48333 12 5C12 3.61667 12.4875 2.4375 13.4625 1.4625C14.4375 0.4875 15.6167 0 17 0H22V5C22 6.38333 21.5125 7.5625 20.5375 8.5375C19.5625 9.5125 18.3833 10 17 10ZM17 8C17.8333 8 18.5417 7.70833 19.125 7.125C19.7083 6.54167 20 5.83333 20 5V2H17C16.1667 2 15.4583 2.29167 14.875 2.875C14.2917 3.45833 14 4.16667 14 5C14 5.21667 14.0208 5.425 14.0625 5.625C14.1042 5.825 14.1667 6.025 14.25 6.225L16.85 3.625C17.0333 3.44167 17.2667 3.35 17.55 3.35C17.8333 3.35 18.0667 3.44167 18.25 3.625C18.45 3.825 18.55 4.0625 18.55 4.3375C18.55 4.6125 18.45 4.85 18.25 5.05L15.65 7.65C15.8667 7.75 16.0875 7.83333 16.3125 7.9C16.5375 7.96667 16.7667 8 17 8Z" fill="#20A7C1"/>
          </g>
        </svg>

        <!-- Clinic Workflow Icon (Green) -->
        <svg v-else-if="automationType === 'workflow' && workflow.type === 'clinic'" xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
          <rect class="icon-bg" width="56" height="56" rx="8" fill="#E5F9EF"/>
          <path class="icon-fill" d="M26.9091 21.4V17H16V36.8H31.2727V34.6H26.9091V32.4H29.0909V30.2H26.9091V28H29.0909V25.8H26.9091V23.6H35.6364V30.2H37.8182V21.4H26.9091ZM20.3636 34.6H18.1818V32.4H20.3636V34.6ZM20.3636 30.2H18.1818V28H20.3636V30.2ZM20.3636 25.8H18.1818V23.6H20.3636V25.8ZM20.3636 21.4H18.1818V19.2H20.3636V21.4ZM24.7273 34.6H22.5455V32.4H24.7273V34.6ZM24.7273 30.2H22.5455V28H24.7273V30.2ZM24.7273 25.8H22.5455V23.6H24.7273V25.8ZM24.7273 21.4H22.5455V19.2H24.7273V21.4ZM40 34.6V36.8H37.8182V39H35.6364V36.8H33.4545V34.6H35.6364V32.4H37.8182V34.6H40ZM33.4545 25.8H31.2727V28H33.4545V25.8ZM33.4545 30.2H31.2727V32.4H33.4545V30.2Z" fill="#20A7C1"/>
        </svg>

        <!-- Patient Workflow Icon (Blue) -->
        <svg v-else xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
          <rect class="icon-bg" width="56" height="56" rx="8" fill="#E0F2FE"/>
          <g transform="translate(16, 16)">
            <path class="icon-fill" d="M12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM6.084 19.536C6.6 18.456 9.744 17.4 12 17.4C14.256 17.4 17.412 18.456 17.916 19.536C16.284 20.832 14.232 21.6 12 21.6C9.768 21.6 7.716 20.832 6.084 19.536ZM19.632 17.796C17.916 15.708 13.752 15 12 15C10.248 15 6.084 15.708 4.368 17.796C3.144 16.188 2.4 14.184 2.4 12C2.4 6.708 6.708 2.4 12 2.4C17.292 2.4 21.6 6.708 21.6 12C21.6 14.184 20.856 16.188 19.632 17.796ZM12 4.8C9.672 4.8 7.8 6.672 7.8 9C7.8 11.328 9.672 13.2 12 13.2C14.328 13.2 16.2 11.328 16.2 9C16.2 6.672 14.328 4.8 12 4.8ZM12 10.8C11.004 10.8 10.2 9.996 10.2 9C10.2 8.004 11.004 7.2 12 7.2C12.996 7.2 13.8 8.004 13.8 9C13.8 9.996 12.996 10.8 12 10.8Z" fill="#004879"/>
          </g>
        </svg>
      </div>

      <!-- Workflow Info -->
      <div class="workflow-info">
        <!-- Title and Actions Row -->
        <div class="title-row">
          <h3 class="workflow-name">{{ workflow.name }}</h3>
          
          <!-- Patient Card Action Buttons - Inline with title -->
          <div v-if="isPatientCard" class="action-buttons patient-actions">
            <!-- Preview Button -->
            <FoldableButton text="Preview" built_in_theme="default" @click.stop="$emit('preview', workflow.id)">
              <template #prefix>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path d="M14.25 2.25H3.75C2.9175 2.25 2.25 2.925 2.25 3.75V14.25C2.25 15.075 2.9175 15.75 3.75 15.75H14.25C15.075 15.75 15.75 15.075 15.75 14.25V3.75C15.75 2.925 15.0825 2.25 14.25 2.25ZM14.25 14.25H3.75V5.25H14.25V14.25ZM9 7.875C10.38 7.875 11.61 8.595 12.255 9.75C11.61 10.905 10.38 11.625 9 11.625C7.62 11.625 6.39 10.905 5.745 9.75C6.39 8.595 7.62 7.875 9 7.875ZM9 6.75C6.9525 6.75 5.205 7.995 4.5 9.75C5.205 11.505 6.9525 12.75 9 12.75C11.0475 12.75 12.795 11.505 13.5 9.75C12.795 7.995 11.0475 6.75 9 6.75ZM9 10.875C8.3775 10.875 7.875 10.3725 7.875 9.75C7.875 9.1275 8.3775 8.625 9 8.625C9.6225 8.625 10.125 9.1275 10.125 9.75C10.125 10.3725 9.6225 10.875 9 10.875Z" fill="currentColor"/>
                </svg>
              </template>
            </FoldableButton>

            <!-- Pause/Start Button - Only show when enrolled -->
            <FoldableButton
              v-if="workflow.isEnrolled"
              :text="workflow.isPaused ? 'Start' : 'Pause'"
              built_in_theme="default"
              @click.stop="$emit('toggle-pause', workflow.id)"
            >
              <template #prefix>
                <svg v-if="workflow.isPaused" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path d="M9 0C4.03125 0 0 4.03125 0 9C0 13.9688 4.03125 18 9 18C13.9688 18 18 13.9688 18 9C18 4.03125 13.9688 0 9 0ZM9 16.3125C4.96875 16.3125 1.6875 13.0312 1.6875 9C1.6875 4.96875 4.96875 1.6875 9 1.6875C13.0312 1.6875 16.3125 4.96875 16.3125 9C16.3125 13.0312 13.0312 16.3125 9 16.3125ZM6.75 5.0625V12.9375L13.5 9L6.75 5.0625Z" fill="currentColor"/>
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path d="M9 0C4.03125 0 0 4.03125 0 9C0 13.9688 4.03125 18 9 18C13.9688 18 18 13.9688 18 9C18 4.03125 13.9688 0 9 0ZM9 16.3125C4.96875 16.3125 1.6875 13.0312 1.6875 9C1.6875 4.96875 4.96875 1.6875 9 1.6875C13.0312 1.6875 16.3125 4.96875 16.3125 9C16.3125 13.0312 13.0312 16.3125 9 16.3125ZM6.75 5.0625H8.4375V12.9375H6.75V5.0625ZM9.5625 5.0625H11.25V12.9375H9.5625V5.0625Z" fill="currentColor"/>
                </svg>
              </template>
            </FoldableButton>

            <!-- Unenroll/Enroll Button -->
            <FoldableButton
              v-if="workflow.isEnrolled"
              text="Unenroll"
              built_in_theme="red"
              @click.stop="$emit('unenroll', workflow.id)"
            >
              <template #prefix>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path d="M10.125 6C10.125 4.3425 8.7825 3 7.125 3C5.4675 3 4.125 4.3425 4.125 6C4.125 7.6575 5.4675 9 7.125 9C8.7825 9 10.125 7.6575 10.125 6ZM8.625 6C8.625 6.825 7.95 7.5 7.125 7.5C6.3 7.5 5.625 6.825 5.625 6C5.625 5.175 6.3 4.5 7.125 4.5C7.95 4.5 8.625 5.175 8.625 6Z" fill="currentColor"/>
                  <path d="M1.125 13.5V15H13.125V13.5C13.125 11.505 9.1275 10.5 7.125 10.5C5.1225 10.5 1.125 11.505 1.125 13.5ZM2.625 13.5C2.775 12.9675 5.1 12 7.125 12C9.1425 12 11.4525 12.96 11.625 13.5H2.625Z" fill="currentColor"/>
                  <path d="M16.875 7.5H12.375V9H16.875V7.5Z" fill="currentColor"/>
                </svg>
              </template>
            </FoldableButton>
            <FoldableButton
              v-else
              text="Enroll"
              built_in_theme="default"
              @click.stop="$emit('enroll', workflow.id)"
            >
              <template #prefix>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path d="M14.25 9.75H9.75V14.25H8.25V9.75H3.75V8.25H8.25V3.75H9.75V8.25H14.25V9.75Z" fill="currentColor"/>
                </svg>
              </template>
            </FoldableButton>
          </div>

          <!-- Action Buttons (My Workflow Only) - Inline with title -->
          <div v-else-if="!isLibrary && !isArchive" class="action-buttons">
            <!-- Edit Button -->
            <FoldableButton text="Edit" built_in_theme="default" @click.stop="$emit('edit', workflow.id)">
              <template #prefix>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0072 2.84917C17.1803 3.11118 17.1514 3.46723 16.9207 3.69788L9.04760 11.5710C8.96280 11.6559 8.85693 11.7165 8.74089 11.7469L5.29531 12.6469C5.18293 12.6762 5.06709 12.6756 4.95826 12.6478C4.84254 12.6184 4.73475 12.5584 4.64743 12.4710C4.47799 12.3016 4.41108 12.055 4.47164 11.8232L5.37164 8.37756C5.39816 8.27603 5.44793 8.17575 5.51676 8.09709L13.4206 0.197703C13.4933 0.125015 13.5808 0.0706142 13.6761 0.0374682C13.7468 0.0129219 13.8217 0 13.8979 0C14.0769 0 14.2486 0.0711158 14.3752 0.197703L16.9207 2.74329C16.9537 2.77624 16.9826 2.81174 17.0072 2.84917ZM15.4888 3.22059L13.8979 1.62959L6.23152 9.29592L5.66904 11.4494L7.82248 10.8869L15.4888 3.22059Z" fill="currentColor"/>
                  <path d="M15.3751 13.4193C15.6211 11.3154 15.6994 9.19692 15.6100 7.08371C15.6057 6.98253 15.6437 6.88408 15.7154 6.81248L16.6003 5.92748C16.7091 5.81867 16.8951 5.88775 16.9052 6.04129C17.0717 8.55197 17.0086 11.074 16.7160 13.5761C16.5030 15.3964 15.0412 16.8229 13.2303 17.0253C10.1104 17.3740 6.88538 17.3740 3.76547 17.0253C1.95461 16.8229 0.492711 15.3964 0.279813 13.5761C-0.0932706 10.3863 -0.0932715 7.16376 0.279813 3.97388C0.492711 2.15361 1.95461 0.727100 3.76547 0.524711C6.13224 0.260189 8.55949 0.196334 10.9554 0.333145C11.1099 0.341962 11.1803 0.528818 11.0709 0.638184L10.1776 1.53149C10.1068 1.60231 10.0096 1.64035 9.90954 1.63697C7.90577 1.56938 5.88837 1.64585 3.91541 1.86636C2.71832 2.00015 1.75937 2.94480 1.62068 4.13071C1.25978 7.21639 1.25978 10.3326 1.62068 13.4193C1.75937 14.6052 2.71832 15.5498 3.91541 15.6836C6.93568 16.0212 10.0601 16.0212 13.0804 15.6836C14.2775 15.5498 15.2364 14.6052 15.3751 13.4193Z" fill="currentColor"/>
                </svg>
              </template>
            </FoldableButton>

            <!-- Archive Button -->
            <FoldableButton text="Archive" built_in_theme="red" @click.stop="$emit('delete', workflow.id)">
              <template #prefix>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0V1H16V3H15V16C15 17.1 14.1 18 13 18H3C1.9 18 1 17.1 1 16V3H0V1H5V0H11ZM3 16H13V3H3V16ZM5 5H7V14H5V5ZM11 5H9V14H11V5Z" fill="currentColor"/>
                </svg>
              </template>
            </FoldableButton>
          </div>

          <!-- Archive Action Buttons (Restore + Delete) -->
          <div v-if="isArchive && !loading" class="action-buttons">
            <!-- Restore Button -->
            <FoldableButton text="Restore" built_in_theme="default" @click.stop="$emit('restore', workflow.id)">
              <template #prefix>
                <img src="@/assets/MyWorkBench/archive/restore.svg" alt="Restore" style="width:18px;height:18px;" />
              </template>
            </FoldableButton>

            <!-- Delete Permanently Button -->
            <FoldableButton text="Permanently Delete" built_in_theme="red" @click.stop="$emit('delete', workflow.id)">
              <template #prefix>
                <img src="@/assets/MyWorkBench/archive/delete.svg" alt="Delete" style="width:18px;height:18px;" />
              </template>
            </FoldableButton>
          </div>
        </div>
        
        <p class="workflow-description">{{ workflow.description }}</p>
      </div>
    </div>
    
    <!-- Footer with Steps and Patients -->
    <div v-if="!isLibrary" class="card-footer">
      <div class="footer-content">
        <span class="footer-text">{{ footerStatusText }}</span>
        <svg v-if="workflow.status === 'active'" xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none">
          <circle cx="2" cy="2" r="2" fill="#999"/>
        </svg>
        <span v-if="workflow.status === 'active'" class="footer-text">{{ workflow.assigned_patients_count || 0 }} assigned patients</span>
      </div>
    </div>
    </div>
  </Loading>
</template>

<script>
import Loading from '@/NewLibrary/Loading/Loading.vue';

export default {
  name: 'WorkflowCard',
  components: {
    Loading,
  },
  
  props: {
    workflow: {
      type: Object,
      required: true,
    },
    viewStyle: {
      type: String,
      default: 'medium',
    },
    isLibrary: {
      type: Boolean,
      default: false,
    },
    automationType: {
      type: String,
      default: 'workflow'
    }, // 'workflow' or 'program'
    isArchive: {
      type: Boolean,
      default: false,
    },
    isPatientCard: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    footerStatusText() {
      if (this.workflow.status === 'archived') return 'Archived';
      return this.workflow.status === 'active' ? 'Active' : 'Draft';
    },
  },
  
  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);
      const now = new Date();
      const diffTime = Math.abs(now - date);
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      
      if (diffDays === 0) return 'Today';
      if (diffDays === 1) return 'Yesterday';
      if (diffDays < 7) return `${diffDays} days ago`;
      if (diffDays < 30) return `${Math.floor(diffDays / 7)} weeks ago`;
      if (diffDays < 365) return `${Math.floor(diffDays / 30)} months ago`;
      return date.toLocaleDateString();
    },
  },
};
</script>

<style scoped>
.workflow-card {
  background: #FFFFFF;
  border: 1px solid #C4C4C4;
  border-radius: 10px;
  padding: 24px;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  height: 144px;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  gap: 8px;
  box-sizing: border-box;
  flex-shrink: 0;
}

.workflow-card:hover {
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
}

/* Archive card hover effect */
.workflow-card:hover.is-archive {
  border: 1px solid var(--VibrantDarkBlue, #004879);
  background: var(--Cool-White, #F9FBFD);
}

/* Hover effect: bold title */
.workflow-card:hover .workflow-name {
  font-weight: 700;
}

/* Workflow hover effect: icon background and fill */
.workflow-card:hover .automation-type-workflow svg rect.icon-bg {
  fill: #004879;
}

.workflow-card:hover .automation-type-workflow svg path.icon-fill {
  fill: #FFFFFF;
}

/* Program hover effect: icon background and fill */
.workflow-card:hover .automation-type-program svg rect.icon-bg {
  fill: #004879;
}

.workflow-card:hover .automation-type-program svg path.icon-fill {
  fill: #FFFFFF;
}

/* Card Content */
.card-content {
  display: flex;
  gap: 12px;
}

.workflow-icon {
  flex-shrink: 0;
  width: 56px;
  height: 56px;
}

.workflow-info {
  flex: 1;
  min-width: 0;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Title Row */
.title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  min-height: 32px;
}

.workflow-name {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #374957;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.workflow-description {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #333;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;

}

/* Action Buttons */
.action-buttons {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
  align-items: center;
  justify-content: flex-end;
}

/* Patient Card Action Buttons */
.patient-actions {
  gap: 2px;
}

/* Card Footer */
.card-footer {
  padding-left: 68px;
}

.footer-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.footer-text {
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: #999;
}
</style>
